/* eslint-disable */
import { Link, withRouter } from "react-router-dom";

const SettingsSidebar = (props) => {
  let pathName = props.location.pathname;
  const user = window.CURRENT_USER;
  return (
    <div className="card">
      <div className="card-body">
        <div className="widget settings-menu">
          <ul>
            <li className="nav-item">
              <Link
                to="/accounts/settings/"
                className={`${
                  "/accounts/settings/" === pathName
                    ? "active nav-link"
                    : "nav-link"
                }`}
              >
                <i className="far fa-user"></i> <span>Account Settings</span>
              </Link>
            </li>
            {user.user_role === "super_admin" && (
              <>
                <li className="nav-item">
                  <Link
                    to="/accounts/company-settings"
                    className={`${
                      "/accounts/company-settings" === pathName
                        ? "active nav-link"
                        : "nav-link"
                    }`}
                  >
                    <i className="fas fa-cog"></i> <span>Company Settings</span>
                  </Link>
                </li>
                {user?.user_role === "super_admin" && (
                  <li className="nav-item">
                    <Link
                      to="/accounts/invoice-settings"
                      className={`${
                        "/accounts/invoice-settings" === pathName
                          ? "active nav-link"
                          : "nav-link"
                      }`}
                    >
                      <i className="far fa-check-square"></i>{" "}
                      <span>Invoice Settings</span>
                    </Link>
                  </li>
                )}
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
export default withRouter(SettingsSidebar);
